export default "__VITE_ASSET__R1pab0z0__"